import { render, staticRenderFns } from "./IngredientsAdd.vue?vue&type=template&id=20dc68d9&scoped=true"
import script from "./IngredientsAdd.vue?vue&type=script&lang=js"
export * from "./IngredientsAdd.vue?vue&type=script&lang=js"
import style0 from "./IngredientsAdd.vue?vue&type=style&index=0&id=20dc68d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc68d9",
  null
  
)

export default component.exports